export default "__VITE_ASSET__CIuDdvFG__"